import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Classes, Menu, MenuDivider } from '@blueprintjs/core';
import Pages from './Pages';

export default class SideMenuLeft extends Component {
  render() {
    return (
      <Menu className={Classes.ELEVATION_1}>
        <MenuDivider title="Filter Settings" />

        {Pages.FilterSettings.sort((x, y) =>
          x.Name.toLowerCase() > y.Name.toLowerCase() ? 1 : -1
        )
          .slice(0, 21)
          .map((Link, LinkIndex) => (
            <li key={LinkIndex} disabled={Link.Disabled}>
              <NavLink
                className={`bp3-menu-item bp3-icon-${Link.Icon}`}
                to={Link.To}
                disabled={Link.Disabled}
              >
                {Link.Name}
              </NavLink>
            </li>
          ))}
      </Menu>
    );
  }
}
